import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomUrbanSimIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d='M12.5031 2.55605C12.5076 2.55605 12.5326 2.59693 12.5722 2.60011C13.1938 2.65143 13.7426 2.72093 14.3492 2.87036C14.4074 2.88444 14.4246 2.84992 14.4124 2.94167L10.5192 6.63798C10.2441 6.4831 9.94537 6.37046 9.63617 6.30233L9.59797 6.24964L9.5957 2.87672C10.1995 2.72138 10.8129 2.65098 11.4336 2.60011C11.4732 2.59693 11.4977 2.5565 11.5027 2.55605C11.7874 2.5347 12.2184 2.5347 12.5031 2.55605Z'
        fill='currentColor'
      />
      <path
        d='M15.5951 9.00072V14.4466H9.59301V10.9066C10.5811 10.7544 11.4032 9.99634 11.5482 9.00027L15.5951 9.00072Z'
        fill='currentcolor'
      />
      <path
        d='M21.8245 14.4466H16.9592V9.00067H21.3016C21.4407 9.1978 21.5153 9.48122 21.5844 9.7165C21.9377 10.9197 22.0741 12.27 21.9613 13.5168C21.9336 13.8257 21.8604 14.1386 21.8245 14.4466Z'
        fill='currentcolor'
      />
      <path
        d='M15.5951 15.1274V19.0758H9.59301V15.1955L9.66121 15.1274H15.5951Z'
        fill='currentcolor'
      />
      <path
        d='M8.91091 15.1274V19.0758H4.4321C3.84235 18.36 3.27124 17.5565 2.9002 16.7017C2.83609 16.5536 2.64921 16.1494 2.68831 16.0204C2.73606 15.8628 3.45949 15.2868 3.61363 15.1274H8.91091Z'
        fill='currentcolor'
      />
      <path
        d='M21.6426 15.1274C21.6785 15.1624 21.4539 15.8151 21.4162 15.9227C20.6927 18.0052 19.134 19.927 17.2461 21.0643C17.1597 21.1161 17.0556 21.1919 16.9592 21.2092V15.1279L21.6426 15.1274Z'
        fill='currentcolor'
      />
      <path
        d='M8.95641 3.10054V6.25454C8.7868 6.36446 8.54809 6.38717 8.35302 6.46938C7.59958 6.78732 7.04939 7.55538 6.95572 8.36477H2.95434L3.26445 7.69845C4.35528 5.78852 6.02176 4.27057 8.04791 3.39623C8.32983 3.2745 8.65449 3.1337 8.95641 3.10054Z'
        fill='currentcolor'
      />
      <path
        d='M6.99982 9.00167C6.95298 9.26375 7.31674 9.64028 7.18488 9.84286L2.18134 14.5375C2.16315 14.2105 2.07539 13.888 2.04402 13.5628C1.92216 12.2947 2.05402 10.9043 2.43097 9.68116C2.46689 9.56443 2.60285 9.1016 2.65741 9.04482C2.80837 8.88903 6.49328 9.07207 6.99982 9.00167Z'
        fill='currentcolor'
      />
      <path
        d='M15.5951 19.7566V21.8895C15.1636 22.0317 14.7302 22.182 14.286 22.2847C12.7545 22.6385 11.1181 22.6217 9.59301 22.2524V19.8243L9.66121 19.7561L15.5951 19.7566Z'
        fill='currentcolor'
      />
      <path
        d='M15.5951 3.73604V8.36529H11.5937C11.6028 8.19769 11.3759 7.7503 11.4327 7.63992L15.5951 3.73604Z'
        fill='currentcolor'
      />
      <path
        d='M21.0515 8.36529H16.9592V3.91773C17.0651 3.94134 17.1797 4.02219 17.2743 4.07988C18.7189 4.96194 19.8974 6.24143 20.7418 7.69898L21.0515 8.36529Z'
        fill='currentcolor'
      />
      <path
        d='M8.91092 14.4466H4.31843L8.18294 10.7476C8.33527 10.6699 8.41439 10.7726 8.53579 10.8044C8.6572 10.8362 8.82089 10.8389 8.91047 10.9293L8.91092 14.4466Z'
        fill='currentcolor'
      />
      <path
        d='M8.95639 22.0258C8.89091 22.0989 8.02107 21.7346 7.8792 21.6711C7.03118 21.29 5.99992 20.6368 5.31741 20.0069C5.24829 19.9433 5.1328 19.8556 5.13644 19.7561H8.88773L8.95594 19.8243L8.95639 22.0258Z'
        fill='currentcolor'
      />
    </SvgIcon>
  );
};

export default CustomUrbanSimIcon;
